import { render } from "./purchase-request.vue?vue&type=template&id=6bc296e5&ts=true"
import script from "./purchase-request.vue?vue&type=script&lang=ts"
export * from "./purchase-request.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__